/**
 * フレーバーカード（コレクション一覧の味別カード展開）
 *
 * 同一商品の複数カードはそれぞれ quick-buy-drawer / quick-buy-popover を持ち、
 * 一度読み込まれたコンテンツは要素内に残り続ける。複数カードのコンテンツが
 * DOM に並存するとフォームID・選択肢IDが衝突し、後から開いた側の操作が
 * 先に読み込まれたフォームへ束縛される。
 *
 * これを防ぐため、クイック購入を開く直前に同じ商品グループの他要素の
 * 読み込み済みコンテンツを破棄し、href を復元して次回開時に再取得させる。
 * fetch 中で href がまだ残っている要素は、読み込み完了イベントの時点で
 * 最後に開かれた要素でなければ破棄する（遅延着弾による二重化の防止）。
 */
(function () {
  'use strict';

  // 複数セクションから読み込まれてもイベント登録は一度だけ行う。
  if (window.majideFlavorCardsInitialized) return;
  window.majideFlavorCardsInitialized = true;

  /** グループごとに最後に開かれた要素を記録する */
  var lastOpened = {};

  function purge(element) {
    var originalHref = element.getAttribute('data-quick-buy-href');
    if (!originalHref) return;
    element.dispatchEvent(new CustomEvent('flavor-set:discard'));
    element.replaceChildren();
    element.setAttribute('href', originalHref);
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('button[aria-controls]');
      if (!button) return;

      var target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target || !target.matches('quick-buy-drawer, quick-buy-popover')) return;

      var group = target.getAttribute('data-quick-buy-group');
      if (!group) return;

      lastOpened[group] = target;

      var selector =
        'quick-buy-drawer[data-quick-buy-group="' + group + '"],' +
        'quick-buy-popover[data-quick-buy-group="' + group + '"]';

      document.querySelectorAll(selector).forEach(function (element) {
        if (element === target) return;

        if (!element.hasAttribute('href')) {
          purge(element);
          return;
        }

        // href が残っている = 未読込か fetch 中。fetch 中の場合は完了後に
        // コンテンツが挿入されるため、その時点で最後に開かれた要素でなければ破棄する。
        // さらに theme.js は load:end の後に open 属性を付与し、+150ms で
        // フォーカストラップを起動するため、閉じ戻しとトラップ解除まで行う
        element.addEventListener(
          'openable-element:load:end',
          function () {
            if (lastOpened[group] === element) return;
            purge(element);
            setTimeout(function () {
              if (lastOpened[group] !== element && element.open) {
                element.open = false;

                // 閉じ戻しは自要素の状態だけを見てページ全体のスクロールロックを
                // 外してしまうため、生存中の要素が開いていればロックを張り直す
                var active = lastOpened[group];
                if (active && active.open) {
                  var lockClass = active.matches('quick-buy-popover') ? 'lock-mobile' : 'lock-all';
                  document.documentElement.classList.add(lockClass);
                }
              }
            }, 0);
            setTimeout(function () {
              if (lastOpened[group] !== element && element._focusTrap) {
                element._focusTrap.deactivate();
              }
            }, 200);
          },
          { once: true }
        );
      });
    },
    true
  );
})();
